export default {
  customized: 'Dostosowany',
  noMatches: 'Nie znaleziono komponentów',
};
